/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.15",
    versionName: "0.2.0-nightly.2026.4.15",
    versionChannel: "nightly",
    buildDate: "2026-04-15T00:20:45.533Z",
    commitHash: "509efacff5b19967e7e93cbdeac1f5fa82133885",
};
